import type { ApiPromise } from "@polkadot/api";
import type { DispatchError } from "@polkadot/types/interfaces";

export const decodeDispatchError = (api: ApiPromise, error: DispatchError) => {
  if (error.isModule) {
    const decoded = api.registry.findMetaError(error.asModule);
    const { docs, section, name } = decoded;
    return `${section}.${name}: ${docs.join(" ")}`;
  }
  return error.toString();
};

export const getFailedType = (lower: string) => {
  let failureType = "Something wrong";
  console.log("Error message:", lower);
  if (lower.includes("rate") || lower.includes("429")) {
    failureType = "Rate limited";
  } else if (lower.includes("insufficient funds")) {
    failureType = "Insufficient funds";
  } else if (
    lower.includes("user rejected") ||
    lower.includes("denied") ||
    lower.includes("cancelled")
  ) {
    failureType = "User rejected";
  } else if (lower.includes("nonce too low")) {
    failureType = "Nonce too low";
  } else if (lower.includes("replacement fee too low")) {
    failureType = "Replacement underpriced";
  } else if (lower.includes("reverted")) {
    // 提取 revert reason（若存在）
    const match = lower.match(
      /reverted(?: with reason string)?[:\s]+("?)([^"]+)\1/i
    );
    failureType = match?.[2] ? `Reverted: ${match[2]}` : "Execution reverted";
  } else if (lower.includes("timeout") || lower.includes("timed out")) {
    failureType = "Network timeout";
  } else if (lower.includes("stake amount is too low")) {
    failureType = "Stake amount is too low";
  } else if (
    lower.includes("miner already bounded") ||
    lower.includes("already bound")
  ) {
    failureType = "Address is already bound to a miner";
  } else if (lower.includes("reached max miner bound")) {
    failureType = "Hotkey has reached max miner bound";
  }
  return failureType;
};
